import config from 'config'
import Promise from 'bluebird'
const SEARCH = 'search'
const SEARCH_FAIL = 'search/fail'
const SEARCH_SUCCESS = 'search/success'

const SHARE_CLASS = 'share_class'
const SHARE_CLASS_FAIL = 'share_class/fail'
const SHARE_CLASS_SUCCESS = 'share_class/success'


const FAMILY_SHARE_CLASS = 'family_share_class'
const FAMILY_SHARE_CLASS_FAIL = 'family_share_class/fail'
const FAMILY_SHARE_CLASS_SUCCESS = 'family_share_class/success'

const initialState = {
  // searched: false
}

function whereParams(prefix,whereBy){
  if(!whereBy){ return {} }
  const params = {}
  whereBy.forEach((where)=>{
    if( where ){
      if( where.op === 'eq' ){
        params[ prefix + '['+ where.name +']'] = where.value
      }else{
        params[ prefix + '['+ where.name +']['+where.op+']'] = where.value
      }
    }
  })
  return params
}
function searchFundParam( params, idx, name, value,whereBy ) {
  // params['filter[where][or][' + idx + '][' + name + '][like]'] = '%' + value + '%'
  params['filter[where][or][' + idx + '][' + name + '][regexp]'] = '/.*' + value + '.*/i'
  // params['filter[where][or][' + idx + '][' + name + '][regexp]'] = '.*'
  params['filter[where][or][' + idx + '][version]'] = config.environment.version
  // params['filter[where][or][' + idx + '][usd_relative_footprint][gt]'] = 0
  params = Object.assign( {}, params, whereParams('filter[where][or][' + idx + ']', whereBy))

  // params['filter[where][and][' + idx + '][portfolio_carbon_relative_carbon_footprint][gt]'] = 0

  return params
}
function baseReducer( state, action, actionTypes){
  switch (action.type) {
    case actionTypes[0]:
      return {
        ...state,
        loading: true,
        loaded: false,
        result: null,
        error: null
      }
    case actionTypes[1]:
      return {
        ...state,
        loading: false,
        loaded: true,
        result: action.result,
        error: null
      }
    case actionTypes[2]:
      return {
        ...state,
        loading: false,
        loaded: false,
        result: null,
        error: action.error
      }
    default:
      return state
  }
}

export function searchReducer(state = initialState, action = {}) {
  return baseReducer( state, action, [SEARCH,SEARCH_SUCCESS,SEARCH_FAIL] )
}
export function shareClassReducer(state = initialState, action = {}) {
  return baseReducer( state, action, [SHARE_CLASS,SHARE_CLASS_SUCCESS,SHARE_CLASS_FAIL] )
}
export function familyShareClassReducer(state = initialState, action = {}) {
  return baseReducer( state, action, [FAMILY_SHARE_CLASS,FAMILY_SHARE_CLASS_SUCCESS,FAMILY_SHARE_CLASS_FAIL] )
}

export function familyShareClasses(fundFamily,page) {
  page = page || 1
  return {
    types: [FAMILY_SHARE_CLASS,FAMILY_SHARE_CLASS_SUCCESS,FAMILY_SHARE_CLASS_FAIL],
    promise: (client) => client.get('/funds', {
      params: {
        'filter[where][fund_family_name]': fundFamily,
        'filter[where][version]': config.environment.version,
        'filter[limit]': config.queryMaxFunds,
        'filter[skip]':(page-1)*config.queryMaxFunds,
        'filter[order]':'fund_net_assets DESC',
        'filter[include]': ['shareclass'],
      }
    })
  }
}

export function shareClassDetails(fundId, investmentVehicleId) {
  return {
    types: [SHARE_CLASS, SHARE_CLASS_SUCCESS, SHARE_CLASS_FAIL],
    promise: (client) => Promise.all([
      client.get('/shareclasses', {
        params: {
          'filter[where][investment_vehicle_id]': investmentVehicleId,
          'filter[where][version]': config.environment.version,
        }
      }),
      client.get('/funds', {
        params: {
          'filter[include]': ['fundholdings','holdings','benchmarks','portfoliocontributors'],
          'filter[where][fund_id]': fundId,
          'filter[where][version]': config.environment.version
        }
      }),
    ]).then((results)=>{
      const shareClassResult = (results[0] && results[0][0]) ? results[0][0] : null
      const fundResult = results[1] && results[1][0] ? results[1][0] : null
      return {
        shareClass: shareClassResult,
        fund: fundResult
      }
    })
  }
}
export function searchFunds(req, page, orderBy, whereBy, isDesc, noLimit ) {
  const defaultSort = [
    // {order:'c2f5coogutweight', isDesc:false},
    {order:'ussif', isDesc:true},
    // {order:'badge_count', isDesc:true},
    {order:'fund_share_class_net_assets', isDesc:true},
  ]


  console.log('searchFunds:', { req:req, page:page, where:( whereBy ? JSON.stringify(whereBy) : '' ), order:orderBy, desc:isDesc, noLimit:noLimit} )
  page = page || 1;

  let params = {
    'filter[limit]': ( noLimit ) ? page*config.queryMaxFunds : config.queryMaxFunds,
    'filter[skip]': (noLimit) ?  0 : (page-1)*config.queryMaxFunds,
    // 'filter[where][portfolio_carbon_relative_carbon_footprint][gt]': 0
  }


  if( orderBy ){
    params = Object.assign( params, {
      'filter[order][0]':orderBy +' ' +(isDesc?'DESC':'ASC'),
      // 'filter[order][1]':'fund_share_class_net_assets DESC',
      // 'filter[order][2]':'name ASC',
    })
    let idx = 1
    // loop through default sorts
    defaultSort.forEach((sort)=>{
      if( sort.order !== orderBy ){
        // if its not orderBy add it
        params[ 'filter[order]['+(idx++)+']'] = sort.order+' ' +(sort.isDesc?'DESC':'ASC')
      }
    })
  }else{
    params = Object.assign( params, {
      // 'filter[order][0]':'badge_count DESC',
      'filter[order][0]':'ussif DESC',
      'filter[order][1]':'fund_share_class_net_assets DESC'
    })
  }

  if( req ){
    // const lowerReq = req.toLowerCase()
    // const upperReq = req.toUpperCase()
    let idx = 0
    params = searchFundParam(params, idx++, 'name', req, whereBy )
    // params = searchFundParam(params, idx++, 'name', lowerReq, whereBy )
    params = searchFundParam(params, idx++, 'fund_legal_name', req, whereBy )
    // params = searchFundParam(params, idx++, 'fund_legal_name', lowerReq, whereBy )
    params = searchFundParam(params, idx++, 'fund_family_name', req, whereBy )
    // params = searchFundParam(params, idx++, 'fund_family_name', lowerReq, whereBy )
    params = searchFundParam(params, idx++, 'ticker', req, whereBy )
    console.log(params)
  }else{
    params = Object.assign( {}, params, whereParams('filter[where]', whereBy))
    params = Object.assign( {}, params, {
      'filter[where][version]': config.environment.version,
      // 'filter[where][portfolio_carbon_relative_carbon_footprint][gt]': 0
    })
  }

  // console.log('searchFunds params:',params )
  return {
    types: [SEARCH, SEARCH_SUCCESS, SEARCH_FAIL],
    promise: (client) => client.get('/shareclasses', {
      params: params
    })
    .then((result) => {
      return { results: result, req:req, orderBy:orderBy }
    })
  }
}


const SECTOR = 'sector'
const SECTOR_FAIL = 'sector/fail'
const SECTOR_SUCCESS = 'sector/success'

export function sectorReducer(state = initialState, action = {}) {
  return baseReducer( state, action, [SECTOR,SECTOR_SUCCESS,SECTOR_FAIL] )
}

export function sectorChange(sectors = {}) {
  return {
    types: [SECTOR,SECTOR_SUCCESS,SECTOR_FAIL],
    promise: (client) => Promise.all([
      new Promise((resolve, reject) => {
        const defaultSectors = { mil: true,
                                 civ: true }
        // if sector param is an empty object, use defaults
        const newSectors = (Object.keys(sectors).length === 0 &&
          sectors.constructor === Object) ? defaultSectors : sectors
        resolve(newSectors)
      })
    ]).then((results)=>{
      return results[0] ? results[0] : null
    })
  }
}


const SIGNUPSUBMIT = 'signupsubmit'
const SIGNUPSUBMIT_FAIL = 'signupsubmit/fail'
const SIGNUPSUBMIT_SUCCESS = 'signupsubmit/success'

export function signupsubmitReducer(state = initialState, action = {}) {
  return baseReducer( state, action, [SIGNUPSUBMIT,SIGNUPSUBMIT_FAIL,SIGNUPSUBMIT_SUCCESS] )
}

export function signupsubmitChange(signupsubmit = false) {
  return {
    types: [SIGNUPSUBMIT,SIGNUPSUBMIT_FAIL,SIGNUPSUBMIT_SUCCESS],
    promise: (client) => Promise.all([
      new Promise((resolve, reject) => {
        resolve(signupsubmit)
      })
    ]).then((results)=>{
      return results[0] ? results[0] : null
    })
  }
}

const TUTORIALDISMISS = 'tutorialdismiss'
const TUTORIALDISMISS_FAIL = 'tutorialdismiss/fail'
const TUTORIALDISMISS_SUCCESS = 'tutorialdismiss/success'

export function tutorialdismissReducer(state = initialState, action = {}) {
  return baseReducer( state, action, [TUTORIALDISMISS,TUTORIALDISMISS_FAIL,TUTORIALDISMISS_SUCCESS] )
}

export function tutorialdismissChange(tutorialdismiss = false) {
  return {
    types: [TUTORIALDISMISS,TUTORIALDISMISS_FAIL,TUTORIALDISMISS_SUCCESS],
    promise: (client) => Promise.all([
      new Promise((resolve, reject) => {
        resolve(tutorialdismiss)
      })
    ]).then((results)=>{
      return results.length ? results[0] : false
    })
  }
}


const COMPANY = 'company'
const COMPANY_SUCCESS = 'company/success'
const COMPANY_FAIL = 'company/fail'

export function companyReducer(state = initialState, action = {}) {
  return baseReducer( state, action, [COMPANY,COMPANY_SUCCESS,COMPANY_FAIL] )
}

export function companies() {
  return {
    types: [COMPANY,COMPANY_SUCCESS,COMPANY_FAIL],
    promise: (client) => client.get('/companies', {
      params: {
        'filter[fields][short_name]': 'true',
        'filter[fields][primary_symbol]': 'true',
        'filter[fields][is_gm]':'true',
        'filter[fields][is_gr]':'true',
        'filter[fields][version]':'true',
        'filter[limit]': 10000,
        'filter[where][or][0][is_gm]':1,
        'filter[where][or][0][version]':config.environment.version,
        'filter[where][or][1][is_gr]':1,
        'filter[where][or][1][version]':config.environment.version,
      }
    })
  }
}


const COMPARE = 'compare'
const COMPARE_FAIL = 'compare/fail'
const COMPARE_SUCCESS = 'compare/success'

export function compareReducer(state = initialState, action = {}) {
  return baseReducer( state, action, [COMPARE,COMPARE_SUCCESS,COMPARE_FAIL] )
}

// up to 4 shareclass ids will be provided
export function compareShareclasses(s1=null, s2=null, s3=null, s4=null) {
  const prefix = 'filter[where][or]['
  const shareclassIds = [s1, s2, s3, s4]
  let count = 0
  const shareclassParams = {
    'filter[limit]': 4,
    'filter[include]': ['fund'],
    'filter[include][fund]': ['shareclass']
  }
  shareclassIds.forEach((id) => {
    if (typeof id !== 'undefined' && id !== null && id !== 'N') {
      shareclassParams[prefix + count + '][investment_vehicle_id]'] = id
      shareclassParams[prefix + count + '][version]'] = config.environment.version
      count += 1
    }
  })
  return {
    types: [COMPARE,COMPARE_SUCCESS,COMPARE_FAIL],
    promise: (client) => client.get('/shareclasses', {
      params: shareclassParams
    })
    .then((result)=>{
      return { results: result }
    })
  }
}

const CART = 'cart'
const CART_FAIL = 'cart/fail'
const CART_SUCCESS = 'cart/success'

export function cartReducer(state = initialState, action = {}) {
  return baseReducer( state, action, [CART,CART_SUCCESS,CART_FAIL] )
}

export function cartChange(cart=[], newShareclass={}) {
  return {
    types: [CART,CART_SUCCESS,CART_FAIL],
    promise: (client) => Promise.all([
      new Promise((resolve, reject) => {
        const CART_MAX = 4
        const EMPTY_SLOT_ID = 'N'
        const generateEmptySlot = () => {
          return { id: EMPTY_SLOT_ID, shareclassStub: {} }
        }
        const defaultCart = []
        for (let i = 0; i < CART_MAX; i++) {
          defaultCart.push(generateEmptySlot())
        }
        if (cart.length !== CART_MAX) {
          cart = defaultCart
        }
        const newId = newShareclass.investment_vehicle_id || EMPTY_SLOT_ID
        // if we actually have a new shareclass to add
        if (newId !== EMPTY_SLOT_ID) {
          let cartIndexOfNewId = -1
          let cartContainsNewId = false
          let cartIndexOfOpenSlot = -1
          let cartContainsOpenSlot = false
          for (let i = 0; i < CART_MAX; i++) {
            if (cart[i].id === newId) {
              cartIndexOfNewId = i
              cartContainsNewId = true
            } else if (cart[i].id === EMPTY_SLOT_ID &&
                       cartIndexOfOpenSlot === -1) {
              cartIndexOfOpenSlot = i
              cartContainsOpenSlot = true
            }
          } 
          if (cartContainsNewId) {
            // if the cart has the id, it's a remove job.
            // assign 'N' to overwrite the shareclass id.
            cart[cartIndexOfNewId] = generateEmptySlot()
          } else {
            // if the cart does not have the id:
            if (cartContainsOpenSlot) {
              // if there's an open slot, we'll add the id and overwrite the N.
              cart[cartIndexOfOpenSlot] = {
                id: newId,
                shareclassStub: {
                  name: newShareclass.name,
                  ticker: newShareclass.ticker,
                  fund_id: newShareclass.fund_id,
                  investment_vehicle_id: newShareclass.investment_vehicle_id,
                  fund_legal_name: newShareclass.fund_legal_name,
                  fund_family_name: newShareclass.fund_family_name
                }
              }
            }
            // if there's no open slots, we'll do nothing.
          }
        }


        resolve(cart)
      })
    ]).then((results)=>{
      const resultsArr = results[0] ? results[0] : null
      return { results: resultsArr }
    })
  }
}


const FUNDS_BY_STRATEGY = 'funds_by_strategy'
const FUNDS_BY_STRATEGY_SUCCESS = 'funds_by_strategy/success'
const FUNDS_BY_STRATEGY_FAIL = 'funds_by_strategy/fail'

export function fundsByStrategyReducer(state = initialState, action = {}) {
  return baseReducer( state, action, [FUNDS_BY_STRATEGY,FUNDS_BY_STRATEGY_SUCCESS,FUNDS_BY_STRATEGY_FAIL] )
}

export function getFundsByStrategy(strategyNames) {
  const gradeField = {
    'Fossil Free Funds': 'grade_fossil',
    'Deforestation Free Funds': 'grade_deforestation',
    'Gender Equality Funds': 'grade_gender_equality',
    'Gun Free Funds': 'grade_guns',
    'Prison Free Funds': 'grade_prison_industrial_complex',
    'Weapon Free Funds': 'grade_military',
    'Tobacco Free Funds': 'grade_tobacco'
  }[config.app.title] || null

  const params = {
    'filter[fields][fund_legal_name]': 'true',
    'filter[fields][fund_id]': 'true',
    'filter[fields][investment_vehicle_id]': 'true',
    'filter[fields][ticker]': 'true',
    'filter[fields][strategy_name]': 'true',
    'filter[fields][version]': 'true',
    'filter[order]':'fund_legal_name ASC',
  }
  if (gradeField) {
    params['filter[fields]['+gradeField+']'] = 'true'
  }
  for (let i = 0; i < strategyNames.length; i++) {
    if (strategyNames[i]) {
      params['filter[where][or]['+i+'][strategy_name]'] = strategyNames[i]
      params['filter[where][or]['+i+'][version]'] = config.environment.version
    }
  }
  return {
    types: [FUNDS_BY_STRATEGY,FUNDS_BY_STRATEGY_SUCCESS,FUNDS_BY_STRATEGY_FAIL],
    promise: (client) => client.get('/funds', { params })
  }
}
